import { API_ROUTES } from '@/constants';

import { apiServices } from './services';

const { coreApiService } = apiServices;

export const getPayWallInfo = async () => coreApiService.get(API_ROUTES.PAYWALL);
